import { ReactNode } from 'react';

import Description from './BrandInfoDescription';
import Heading from './BrandInfoHeading';
import LogoContainer from './BrandInfoLogo';
import SubHeading from './BrandInfoSubHeading';

const BrandInfo = ({ children }: { children?: ReactNode }) => {
    return <div>{children}</div>;
};

BrandInfo.LogoContainer = LogoContainer;
BrandInfo.Heading = Heading;
BrandInfo.SubHeading = SubHeading;
BrandInfo.Description = Description;

export default BrandInfo;
